const FORMAT_MIME = {
  jpg: "image/jpeg",
  png: "image/png",
};

const sanitizeFileName = (name) =>
  String(name || "image")
    .replace(/[\\/:*?"<>|]+/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "") || "image";

const loadImageFromBlob = (blob) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("image-decode-failed"));
    };
    img.src = objectUrl;
  });

const canvasToBlob = (canvas, mime) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (result) => (result ? resolve(result) : reject(new Error("canvas-export-failed"))),
      mime,
      0.95
    );
  });

const triggerBrowserDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * Downloads an image URL re-encoded as JPG or PNG.
 * JPG has no alpha channel, so transparent areas are flattened onto white.
 */
export const downloadImageAs = async (src, format, baseName) => {
  const mime = FORMAT_MIME[format];
  if (!src || !mime) throw new Error("invalid-download-request");

  const response = await fetch(src);
  if (!response.ok) throw new Error(`download-failed-${response.status}`);
  const sourceBlob = await response.blob();

  let outputBlob = sourceBlob;
  if (sourceBlob.type !== mime) {
    const img = await loadImageFromBlob(sourceBlob);
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    if (mime === "image/jpeg") {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage(img, 0, 0);
    outputBlob = await canvasToBlob(canvas, mime);
  }

  triggerBrowserDownload(outputBlob, `${sanitizeFileName(baseName)}.${format}`);
};

export default downloadImageAs;
